export const hasStatisticsConsent = () =>
    Boolean(window.Cookiebot && window.Cookiebot.hasResponse && window.Cookiebot.consent.statistics);
